<template>
  <div id="app">
    <Header id="header"></Header>
    <router-view id="router"/>
    <Modals></Modals>
  </div>
</template>

<script>

import Header from '@/views/Header.vue'
import Modals from '@/components/Modals.vue'

export default {

  components: {
    Header,
    Modals
  },
  computed: {
    extensionInstalled: function () {
      return this.$store.state.extension.installed
    },
  },
  methods: {
    removeFbQuery: function () {
      if(this.$route.query.fbclid) {
        let query = Object.assign({}, this.$route.query);
        query.fbclid = undefined;
        this.$router.push({path: this.$route.path, query: query})
      }
    },
  },
  mounted: function () {

    this.removeFbQuery();
    this.$store.dispatch('socket/init')
    this.$store.dispatch('speech/init')

    let self = this
    window.addEventListener("message", function(data) {
      if((data.origin == 'http://localhost:8080' || data.origin == 'https://textify.cc') && data.data.fromExtension){
        if(data.data.name == 'extensionInstalled'){
          self.$store.dispatch('extension/init')
          self.$store.commit('extension/setInstalled',{installed:true});
        }
        else if(data.data.name == 'setMode'){
          self.$store.commit('extension/setMode',{mode: data.data.mode});
        }
        else if(data.data.name == 'getWebpageData'){
          self.$store.commit('extension/setMode',{mode: data.data.data.mode});
        }
      }
    })

  }

}
</script>

<style lang="scss">

  @import './assets/style/layout.scss';
  @import './assets/style/text.css';
  @import './assets/style/elements.css';
  @import './assets/style/form.css';
  @import './assets/style/colors.css';
  @import './assets/style/screens.scss';

</style>
